export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8329.7e2b9b0c.jpg";